export default "__VITE_ASSET__1M1eNUG7__"